export interface FemaleLookUp {
  id: number;
  name: string;
  nameEN: string;
  fName: null;
  fNameEN: null;
  isDeleted: boolean;
}
